import type { LucideIcon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

export default function FeatureCard({ icon: Icon, title, description }: FeatureCardProps) {
  const { theme } = useTheme();

  return (
    <article className="rounded-lg border bg-white p-5 shadow-sm" style={{ borderColor: theme.border, backgroundColor: theme.surface }}>
      <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-lg bg-blue-50">
        <Icon className="h-5 w-5" style={{ color: theme.primary }} />
      </div>
      <h3 className="mb-2 text-base font-bold" style={{ color: theme.text }}>
        {title}
      </h3>
      <p className="mb-0 text-sm leading-6" style={{ color: theme.textSecondary }}>
        {description}
      </p>
    </article>
  );
}
